import { render, staticRenderFns } from "./AiHelper.vue?vue&type=template&id=f561e4e8&scoped=true&"
import script from "./AiHelper.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AiHelper.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AiHelper.vue?vue&type=style&index=0&id=f561e4e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f561e4e8",
  null
  
)

export default component.exports